import {
  useCallback,
  useEffect,
  useState,
  FunctionComponent,
  SyntheticEvent,
} from 'react';
import { useYaMetrica } from '~frontend/provider/yametrica';
import _ from 'lodash';
import { addPercent } from '~ui/Price';
import { useTranslation } from 'react-i18next';
import { useToggle } from 'react-use';
import playAudio from '~frontend/utils/playAudio';
import {
  useUpgradeAmount,
  useItemRight,
  useWinItem,
  useStatusGame,
  useChance,
  useLoseGame,
} from './hooks';

// import IconLoose from '../../scss/images/icon-loose.svg';
import IconWarning from '../../scss/images/icon-upgrade-4.png';

import { LooseItem } from './LooseItem';
import WinItem from './WinItem';
import { useGetGaTestId } from '../hooks';

const UpgradeCenter: FunctionComponent = () => {
  const { t } = useTranslation();
  const [itemRight] = useItemRight();
  const [upgradeAmount] = useUpgradeAmount();
  const [winItem] = useWinItem();
  const [looseItem] = useLoseGame();
  const [statusGame, setStatusGame] = useStatusGame();
  const [linesChange, setLinesChange] = useToggle(false);
  const [rotate, setRotate] = useState(0);
  const [chance, setChance] = useChance();
  const yametrica = useYaMetrica();

  const reachGoal = (
    event: SyntheticEvent<HTMLElement>,
    { reachgoal } = event?.currentTarget?.dataset ||
      (event.target as HTMLElement)?.dataset,
  ) => {
    yametrica.reachGoal(reachgoal);
  };

  useEffect(() => {
    if (upgradeAmount > 0 && itemRight) {
      setStatusGame(1);
    }
  }, [upgradeAmount, itemRight, setStatusGame]);

  useEffect(() => {
    if (statusGame === 2) {
      const rotateRight = _.random(10, 170);
      const rotateLeft = _.random(190, 350);

      let rotate = !linesChange ? rotateLeft : rotateRight;

      if (winItem) {
        rotate = !linesChange ? rotateRight : rotateLeft;
      }

      setRotate(rotate + 360 * _.random(2, 5));
    } else if (statusGame < 2) {
      setRotate(0);
    }
  }, [statusGame, winItem]);

  useEffect(() => {
    const selectedItemsForUpgradePrice = upgradeAmount;
    const itemPrice = addPercent(itemRight?.price, 30);

    let chance = ((itemPrice - selectedItemsForUpgradePrice) * 100) / itemPrice;

    chance = 100 - chance;

    setChance(chance >= 100 ? 100 : _.round(chance, 2));
  }, [upgradeAmount, itemRight]);

  const onLinesChange = useCallback(
    event => {
      if (statusGame !== 1) {
        return null;
      }

      playAudio(event);

      reachGoal(null, { reachgoal: 'neonlines_click' });

      setLinesChange();
    },
    [statusGame, setLinesChange],
  );

  const className = winItem ? 'win' : looseItem && 'loose';

  const [_ga_ab] = useGetGaTestId();

  return (
    <div
      className={`upgrade-main-center ${statusGame && 'active'} ${
        statusGame === 3 ? className : ''
      }`}
    >
      <div className="center-wrap">
        <div
          className="neon-arrow"
          style={{ transform: `translate(-50%, -50%) rotate(${rotate}deg)` }}
        ></div>
        <div className="center-item">
          {/* <div className="load-block"></div> */}
          <div className="neon-wrap">
            <>
              <div
                className="neon-lines"
                // className={`neon-lines ${linesChange && 'change'} ${
                //   _ga_ab === 1 && 'reverse-line'
                // }`}
                onClick={onLinesChange}
                data-audio="4.wav"
                data-volume="0.15"
              >
                <div
                  className={`neon-lines-left ${upgradeAmount > 0 && 'active'}`}
                />
                <div className={`neon-lines-right ${itemRight && 'active'}`} />
              </div>
              <div className="neon-center">
                <>
                  <div className="water-animate">
                    <div className="water-animate-water-1" />
                    <div className="water-animate-water-2" />
                  </div>
                  {statusGame > 0 ? (
                    itemRight?.price < upgradeAmount ? (
                      <>
                        <span
                          className="icon material-icons"
                          data-icon="warning"
                        />
                        <div className="text">{t('upgrades_cheap_item')}</div>
                      </>
                    ) : (
                      <>
                        <div className="percent">
                          {_.isNaN(chance) ? 0 : chance}%
                        </div>
                        <div className="text">
                          {t('Probability of Success')}
                          <br />
                          {t('upgrade')}
                        </div>
                      </>
                    )
                  ) : (
                    <>
                      <span
                        className="icon material-icons"
                        data-icon="warning"
                      />
                      <div className="text">
                        {t('No upgrade items selected')}
                      </div>
                    </>
                  )}
                </>
              </div>
            </>
            {winItem ? <WinItem /> : looseItem && <LooseItem />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradeCenter;
